// src/hooks/useViewportHeight.ts
import { useEffect } from "react";

export default function useViewportHeight() {
  useEffect(() => {
    const setVh = () => {
      const vv = window.visualViewport;
      const height = (vv?.height ?? window.innerHeight) * 0.01;
      const offsetTop = vv?.offsetTop ?? 0;
      const topInsetFallback = Math.max(
        0,
        window.innerHeight - (vv?.height ?? window.innerHeight) - offsetTop
      );
      document.documentElement.style.setProperty("--app-vh", `${height}px`);
      document.documentElement.style.setProperty("--app-vv-top", `${offsetTop}px`);
      document.documentElement.style.setProperty("--app-top-inset", `${topInsetFallback}px`);
    };
    setVh();
    window.addEventListener("resize", setVh);
    window.addEventListener("scroll", setVh);
    window.visualViewport?.addEventListener("resize", setVh);
    window.visualViewport?.addEventListener("scroll", setVh);
    return () => {
      window.removeEventListener("resize", setVh);
      window.removeEventListener("scroll", setVh);
      window.visualViewport?.removeEventListener("resize", setVh);
      window.visualViewport?.removeEventListener("scroll", setVh);
    };
  }, []);
}
